import { Theme } from '@blockanalitica/ui/package/types/src/theme/ThemeProvider';
import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function displaySwitchOption(theme: Theme): ComponentStyle {
  return {
    componentName: 'displaySwitchOption',
    baseStyle: {
      padding: `${theme.space['2xs']} ${theme.space['xs']}`,
      fontSize: theme.sizes['-1'],
      fontWeight: 600,
      color: theme.colors.spark.gray40,
      borderRadius: theme.sizes['-3'],

      ['&:hover']: {
        backgroundColor: theme.colors.spark.gray90,
        color: theme.colors.primary
      }
    },
    states: {
      active: {
        backgroundColor: theme.colors.spark.gray80,
        color: theme.colors.text,
        ['&:hover']: {
          backgroundColor: theme.colors.spark.gray90
        }
      }
    }
  };
}
